import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppcoreService } from 'src/app/shared/services/appcore';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const authenticatedRedirectGuard = (): Observable<true | UrlTree> => {
  const appcoreService = inject(AppcoreService);
  const router = inject(Router);

  return appcoreService.isAuthenticated().pipe(
    map(authenticated => {
      if (authenticated) {
        return router.parseUrl('/');
      }

      return true;
    })
  );
};

export const authorisedRedirectGuard = (): Observable<true | UrlTree> => {
  const appcoreService = inject(AppcoreService);
  const router = inject(Router);

  return appcoreService.isAuthorised().pipe(
    map(authorised => {
      if (authorised) {
        return router.parseUrl('/');
      }

      return true;
    })
  );
};
